
export default {
    name: 'prestation',
    components: {},
    props: {
        prestations: Array,
        prestation_index: Number,
        tot_montant_du: Number,
        tot_montant_paye: Number,
        tot_montant_restant: Number
    },
    data() {
        return {
            fields: [
                { key: 'libelle', label: 'Libellé' }, { key: 'qte', label: 'Qté' },
                { key: 'montant_du', label: 'Montant dû' }, { key: 'montant_paye', label: 'Montant payé' },
                { key: 'montant_restant', label: 'Montant restant' }    
            ],
            fields_patient: [
                { key: 'num_dossier', label: 'N° dossier' }, 'patient', { key: 'telephone', label: 'Téléphone' },
                { key: 'qte', label: 'Qté' }, { key: 'montant_du', label: 'Montant dû' },
                { key: 'montant_paye', label: 'Montant payé' }, { key: 'montant_restant', label: 'Montant restant' },
                'date'
            ],
           
            filter: "",
            filter_patient: "",
            perPage: 50,
            print_per_page: -1,
            currentPage: 1,
            liste_patients: [],
            modal_index: 0,
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        viewPatient(data, index) {
            this.liste_patients = data.patients
            this.modal_index = index
        }
    }
}


